<template>
  <div id="app">
    <GenericErrorModal />
    <MainLayout v-if="$route.meta && $route.meta.sideBar" />
    <router-view v-if="$route.meta && !$route.meta.sideBar" />
    <cookie-law
      theme="blood-orange--rounded"
      message="Cookies help us deliver our Services. By using our Services or clicking I agree, you agree to our use of cookies."
      position="bottom"
      buttonText="I AGREE"
    ></cookie-law>
  </div>
</template>

<script>
import MainLayout from "./components/MainLayout";
import GenericErrorModal from "./components/GenericErrorModal";
import { mapGetters } from "vuex";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import CookieLaw from "vue-cookie-law";

export default {
  components: {
    MainLayout,
    GenericErrorModal,
    CookieLaw
  },
  computed: mapGetters(["allPosts"])
};
</script>
<style lang="scss"></style>
